import React from 'react';

export default function StatCard({ label, value, sub, icon, trend, accent = 'blue' }) {
  const accentColors = {
    blue: 'text-blue-400',
    green: 'text-green-400',
    yellow: 'text-yellow-400',
    red: 'text-red-400',
    orange: 'text-orange-400',
  };

  const iconBg = {
    blue: 'bg-blue-500/10',
    green: 'bg-green-500/10',
    yellow: 'bg-yellow-500/10',
    red: 'bg-red-500/10',
    orange: 'bg-orange-500/10',
  };

  return (
    <div className="card flex flex-col gap-3">
      <div className="flex items-start justify-between">
        <span className="text-xs font-semibold text-gray-400 uppercase tracking-wider">{label}</span>
        {icon && (
          <span className={`p-2 rounded-lg ${iconBg[accent]}`}>
            <span className={`${accentColors[accent]} text-base`}>{icon}</span>
          </span>
        )}
      </div>
      <div className="flex items-end justify-between gap-2">
        <div>
          <div className={`text-2xl font-bold ${accentColors[accent]}`}>{value}</div>
          {sub && <div className="text-xs text-gray-500 mt-0.5">{sub}</div>}
        </div>
        {trend != null && (
          <div className={`text-xs font-medium ${trend >= 0 ? 'text-green-400' : 'text-red-400'}`}>
            {trend >= 0 ? '▲' : '▼'} {Math.abs(trend)}%
          </div>
        )}
      </div>
    </div>
  );
}
